const translations = {
    'tabs.buildings': 'Budynki',
    'tabs.buildings.core': 'Rdzeń',
    'tabs.buildings.food': 'Żywność',
    'tabs.buildings.industry': 'Przemysł',
    'tabs.buildings.mining': 'Górnictwo',
    'tabs.buildings.craft': 'Rzemiosło',
    'tabs.buildings.support': 'Wsparcie',
    'tabs.forest': 'Las',
    'tabs.jobs': 'Prace',
    'tabs.jobs.core': 'Rdzeń',
    'tabs.jobs.food': 'Żywność',
    'tabs.jobs.industry': 'Przemysł',
    'tabs.jobs.mining': 'Górnictwo',
    'tabs.jobs.craft': 'Rzemiosło',
    'tabs.jobs.support': 'Wsparcie',
    'tabs.log': 'Dziennik',
    'tabs.nature': 'Natura',
    'tabs.production': 'Produkcja',
    'tabs.population': 'Populacja',
    'tabs.storage': 'Magazyn',
    'tabs.tools': 'Narzędzia',
    'tabs.wildlife': 'Dzika zwierzyna',
    'tabs.assistants': 'Agenci',
    'tabs.assistants.title': 'Agenci',
};

export default translations;
